"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deliveryNoteToCode = exports.deliveryNoteFromCode = void 0;
const errors_1 = require("@wolf/errors");
const delivery_note_1 = require("./models/delivery-note");
const types_1 = require("./types");
const utils_1 = require("./utils");
// Array, not object: JS orders integer-like keys numerically, which would move (251) to the end
const deliveryNoteAI = [
    ['90', 'type'],
    ['20', 'sourceId'],
    ['251', 'workspaceId'],
    ['91', 'deliveryGroupId'],
    ['95', 'deliveryNoteId'],
    ['96', 'version'],
];
const fieldByAI = new Map(deliveryNoteAI);
const deliveryNoteFromCode = (code) => {
    const codes = (0, utils_1.stringToCodes)(code);
    if (!Array.isArray(codes)) {
        throw new errors_1.BadRequestError(errors_1.BAD_REQUEST_ERROR_CODES.BAD_PICKING_INPUT, 'Incorrect format');
    }
    const deliveryNote = codes.reduce((previousCodes, code) => {
        const field = code.code ? fieldByAI.get(code.code) : undefined;
        return field ? { ...previousCodes, [field]: Number(code.value) } : previousCodes;
    }, {});
    const deliveryNoteParse = delivery_note_1.DeliveryNoteFromBarcode.safeParse(deliveryNote);
    if (!deliveryNoteParse.success || deliveryNoteParse.data.type !== Number(types_1.type.deliveryNote)) {
        throw new errors_1.BadRequestError(errors_1.BAD_REQUEST_ERROR_CODES.BAD_PICKING_INPUT, 'Invalid identifier');
    }
    return deliveryNoteParse.data;
};
exports.deliveryNoteFromCode = deliveryNoteFromCode;
const deliveryNoteToCode = (deliveryNote) => {
    // Iterate the AI list (not the input keys) so the code is identical regardless of key order
    const code = deliveryNoteAI
        .filter((entry) => entry[1] !== 'type')
        .reduce((previousCode, [ai, field]) => {
        return previousCode + '(' + ai + ')' + (0, utils_1.formatToCode)(deliveryNote[field]);
    }, '');
    return types_1.typeIA + types_1.type.deliveryNote + code;
};
exports.deliveryNoteToCode = deliveryNoteToCode;
//# sourceMappingURL=delivery-note.js.map